import DashboardsMenuContainer from './containers/DashboardsMenuContainer';

export default DashboardsMenuContainer;
